// extracted by mini-css-extract-plugin
module.exports = {"bp-min-sm":"(min-width: 520px)","accolades":"VenueAccolades-module--accolades--15442c","accolade":"VenueAccolades-module--accolade--34897b"};